import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
interface StepProgressProps {
  currentStep: 1 | 2;
}
const steps = [{
  number: 1,
  label: 'Configure'
}, {
  number: 2,
  label: 'Proof'
}, {
  number: 3,
  label: 'Purchase'
}];
export function StepProgress({
  currentStep
}: StepProgressProps) {
  return <div className="flex items-center justify-center gap-0 mb-8" data-id="element-414">
      {steps.map((step, i) => {
      const isCompleted = step.number < currentStep;
      const isActive = step.number === currentStep;
      const isUpcoming = step.number > currentStep;
      return <Fragment key={step.number} data-id="element-415">
            <div className="flex flex-col items-center" data-id="element-416">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-colors ${isCompleted ? 'bg-[#008696] text-white' : isActive ? 'bg-[#008696] text-white ring-2 ring-[#EAF6F7]' : 'bg-white border-2 border-[#D9D9D9] text-[#5F5F5F]'}`} data-id="element-417">
                {isCompleted ? <Check size={16} strokeWidth={3} data-id="element-418" /> : step.number}
              </div>
              <span className={`text-xs font-medium mt-1.5 ${isCompleted || isActive ? 'text-[#008696]' : 'text-[#5F5F5F]'}`} data-id="element-419">
                {step.label}
              </span>
            </div>
            {i < steps.length - 1 && <div className={`w-16 h-0.5 mb-5 ${step.number < currentStep ? 'bg-[#008696]' : 'bg-[#D9D9D9]'}`} data-id="element-420" />}
          </Fragment>;
    })}
    </div>;
}